import './components/NativeImage'
import './components/StickyNav'
import './components/MobileNav'
import './components/StickyColumn'
import './components/AutoplayVideo'
import './components/VideoEmbed'
import './components/HomeJump'
import './components/PastTheFold'
import HoverCaption from './components/HoverCaption'
import TwIntersect from './lib/twIntersect'

// Initialize hover captions
new HoverCaption()

// Initialize Tailwind intersection observer
new TwIntersect().init()